import client from '../../shared/api/client';
import {
  P2pOfferType,
  P2pRestriction,
  P2pRestrictionType,
  PaginatedResponse,
} from '../../shared/types';

interface RestrictionBackendResponse<T> {
  status: string;
  data: T;
}

export interface RestrictionsFilters {
  page?: number;
  per_page?: number;
  search?: string;
  type?: P2pRestrictionType;
  currency?: string;
  fiat_currency?: string;
  is_active?: boolean;
  mode?: 'p2p' | 'otc';
}

export interface RestrictionInput {
  mode?: 'p2p' | 'otc';
  name: string;
  description?: string | null;
  type: P2pRestrictionType;
  currencies?: string[];
  fiat_currencies?: string[];
  offer_type?: P2pOfferType | null;
  min_verification_level: number;
  is_active?: boolean;
}

export const listRestrictions = async (
  filters: RestrictionsFilters = {}
): Promise<PaginatedResponse<P2pRestriction>> => {
  const params: Record<string, string | number | boolean | undefined> = {
    page: filters.page ?? 1,
    per_page: filters.per_page ?? 20,
  };
  if (filters.search) params.search = filters.search;
  if (filters.type) params.type = filters.type;
  if (filters.currency) params.currency = filters.currency;
  if (filters.fiat_currency) params.fiat_currency = filters.fiat_currency;
  if (typeof filters.is_active === 'boolean') params.is_active = filters.is_active;
  if (filters.mode) params.mode = filters.mode;
  const response = await client.get<RestrictionBackendResponse<PaginatedResponse<P2pRestriction>>>(
    '/p2p/restrictions',
    { params }
  );
  return response.data.data;
};

export const getRestriction = async (id: number): Promise<P2pRestriction> => {
  const response = await client.get<RestrictionBackendResponse<P2pRestriction>>(`/p2p/restrictions/${id}`);
  return response.data.data;
};

export const createRestriction = async (data: RestrictionInput): Promise<P2pRestriction> => {
  const response = await client.post<RestrictionBackendResponse<P2pRestriction>>('/p2p/restrictions', data);
  return response.data.data;
};

export const updateRestriction = async (
  id: number,
  data: Partial<RestrictionInput>
): Promise<P2pRestriction> => {
  const response = await client.put<RestrictionBackendResponse<P2pRestriction>>(`/p2p/restrictions/${id}`, data);
  return response.data.data;
};

export const deleteRestriction = async (id: number): Promise<void> => {
  await client.delete(`/p2p/restrictions/${id}`);
};
